module.exports = __webpack_public_path__ + "static/media/point_icon_02.e898e25f.svg";